import React, { useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { IoPeopleOutline, IoCashOutline, IoArrowBack, IoDocumentTextOutline, IoAnalyticsOutline, IoShieldCheckmarkOutline, IoCheckboxOutline, IoTrendingUpOutline, IoTimerOutline } from "react-icons/io5";
import KondoSidebar from '../components/Shared/KondoSidebar';
import KondoBrandHeader from '../components/Shared/KondoBrandHeader';
import KondoBottomNav from '../components/Shared/KondoBottomNav';
import { useAuth } from '../context/AuthContext';
import { checkPermission, PERMISOS_SAAS } from '../utils/permisos';
import { seedSatTaxTables } from '../utils/satTaxesSeeder';
import { IoCalculatorOutline } from "react-icons/io5";
import './HomeScreen.css'; // Reusing Home Styles for cards

const MenuCard = ({ onClick, icon, title, subtitle, theme }) => (
    <div className="ks-card" onClick={onClick}>
        <div className={`ks-card-icon ${theme}`} style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
            {icon}
        </div>
        <div className="ks-card-body">
            <h3>{title}</h3>
            <span style={{ fontSize: '0.75rem', color: 'var(--kondo-subtle)', fontWeight: 500, marginTop: '4px', display: 'block' }}>{subtitle}</span>
        </div>
    </div>
);

function NominasDashboardScreen() {
    const navigate = useNavigate();
    const location = useLocation();
    const { userData } = useAuth();
    const [showSATSuccessModal, setShowSATSuccessModal] = useState(false);

    const handleUpdateSatTables = async () => {
        try {
            await seedSatTaxTables();
            setShowSATSuccessModal(true);
        } catch (e) {
            console.error(e);
            alert("Error al actualizar las tablas del SAT.");
        }
    };
    
    // Determinamos si estamos en el contexto "SaaS Corporativo" o "B2B Condominio"
    const isSaaS = location.pathname.includes('/superuser/hr');
    const basePath = isSaaS ? '/superuser/hr' : '';

    return (
        <div className="ks-page">
            <KondoSidebar activeRoute="/nominas-dashboard" />
            <main className="ks-main">
                <div className="ks-header-sticky-wrapper">
                    <KondoBrandHeader showBack={false} />
                </div>
                <div className="ks-scroll-area">
                    <div className="ks-content-area" style={{ paddingTop: '15px' }}>
                        {/* Header Banner */}
                        <div className="muro-header-stitch" style={{ marginBottom: '20px' }}>
                            <div className="muro-hero-card" style={isSaaS ? undefined : { background: 'linear-gradient(135deg, #0ea5e9 0%, #0369a1 100%)' }}>
                                <div className="muro-hero-content">
                                    <h1>{isSaaS ? 'RH y nóminas' : 'Portal de Nóminas'}</h1>
                                    <p>{isSaaS ? 'Gestión de corporativo y colaboradores' : 'Gestión de capital humano y nóminas'}</p>
                                </div>
                                <IoPeopleOutline className="muro-hero-icon-decor" />
                            </div>
                        </div>

                        <div className="ks-section-label">Módulos de RRHH</div>
                        <div className="ks-modules-grid" style={{ marginBottom: '20px' }}>
                            <MenuCard
                                onClick={() => navigate(`${basePath}/gestion-empleados`)}
                                icon={<IoPeopleOutline size={22} />}
                                title="Catálogo RRHH"
                                subtitle="Empleados, expedientes y salarios"
                                theme="theme-orange"
                            />
                            <MenuCard
                                onClick={() => navigate(`${basePath}/gestion-nomina`)}
                                icon={<IoCashOutline size={22} />}
                                title="Nómina y Fiscal"
                                subtitle="Cálculos pre-nómina e impuestos"
                                theme="theme-green"
                            />
                             <MenuCard
                                onClick={() => navigate(isSaaS ? '/superuser/hr/actividades' : '/hr/actividades')}
                                icon={<IoCheckboxOutline size={22} />}
                                title="Control Actividades"
                                subtitle="Asignación de tareas operativas"
                                theme="theme-indigo"
                            />
                            <MenuCard
                                onClick={() => navigate(isSaaS ? '/superuser/hr/metas' : '/hr/metas')}
                                icon={<IoTrendingUpOutline size={22} />}
                                title="Objetivos y Metas"
                                subtitle="Asignar bonos y objetivos"
                                theme="theme-purple"
                            />
                            <MenuCard
                                onClick={() => navigate(isSaaS ? '/superuser/hr/timesheets' : '/hr/timesheets')}
                                icon={<IoTimerOutline size={22} />}
                                title="Aprobación Jornadas"
                                subtitle="Validar asistencias y check-ins"
                                theme="theme-blue"
                            />
                            <MenuCard
                                onClick={() => navigate(isSaaS ? '/superuser/hr/mi-checador' : '/trabajador/dashboard')}
                                icon={<IoTimerOutline size={22} />}
                                title="Mi Checador"
                                subtitle="Registrar asistencia y tareas de staff"
                                theme="theme-blue"
                            />
                            {isSaaS && (
                                <MenuCard
                                    onClick={handleUpdateSatTables}
                                    icon={<IoCalculatorOutline size={22} />}
                                    title="Actualizar Tablas SAT"
                                    subtitle="Poblar tarifas de ISR vigentes"
                                    theme="theme-purple"
                                />
                            )}
                            {isSaaS && (checkPermission(userData, PERMISOS_SAAS.EDITAR_PERMISOS) || checkPermission(userData, PERMISOS_SAAS.CREAR_USUARIOS)) && (
                                <MenuCard
                                    onClick={() => navigate(`${basePath}/accesos`)}
                                    icon={<IoShieldCheckmarkOutline size={22} />}
                                    title="Accesos Corporativos"
                                    subtitle="Gestión de roles y miembros SaaS"
                                    theme="theme-gray"
                                />
                            )}
                        </div>

                        <div className="ks-section-label">Reportes y Obligaciones</div>
                        <div className="ks-modules-grid">
                            <MenuCard
                                onClick={() => {
                                    if (isSaaS) {
                                        if (checkPermission(userData, PERMISOS_SAAS.ACCESO_MODULO_DISPERSION)) {
                                            navigate(`${basePath}/dispersion-nomina`);
                                        } else {
                                            alert('Acceso Denegado: No cuentas con el permiso "ACCESO_MODULO_DISPERSION".');
                                        }
                                    } else {
                                        navigate('/gestion-facturas', { state: { viewContext: 'nominas' } });
                                    }
                                }}
                                icon={<IoDocumentTextOutline size={22} />}
                                title="Dispersión y Timbrado"
                                subtitle="Ir a Pago de Nóminas Autorizadas"
                                theme="theme-purple"
                            />
                            <MenuCard
                                onClick={() => navigate(`${basePath}/obligaciones-fiscales`)}
                                icon={<IoAnalyticsOutline size={22} />}
                                title="Declaraciones y SAT"
                                subtitle="Cruce de IVA, ISR e IMSS/Infonavit"
                                theme="theme-blue"
                            />
                        </div>
                    </div>
                </div>
                <KondoBottomNav activeRoute="/nominas-dashboard" />
                {/* Modal de éxito de actualización de tablas SAT */}
                {showSATSuccessModal && (
                    <div className="modal-overlay" style={{ zIndex: 10960, display: 'flex', alignItems: 'center', justifyContent: 'center', position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, background: 'rgba(15, 23, 42, 0.6)', backdropFilter: 'blur(4px)' }}>
                        <div className="modal-content" style={{ maxWidth: '400px', background: 'white', borderRadius: '16px', boxShadow: '0 20px 25px -5px rgba(0,0,0,0.1), 0 10px 10px -5px rgba(0,0,0,0.04)', padding: '0', overflow: 'hidden' }}>
                            <div className="modal-header" style={{ padding: '20px', background: '#f5f3ff', borderBottom: '1px solid #ddd6fe', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                <h3 style={{ margin: 0, color: '#6d28d9', fontSize: '1.15rem', fontWeight: 'bold' }}>
                                    Tablas SAT Actualizadas
                                </h3>
                                <button onClick={() => setShowSATSuccessModal(false)} style={{ background: 'none', border: 'none', color: '#6d28d9', fontSize: '1.5rem', cursor: 'pointer', lineHeight: 1 }}>&times;</button>
                            </div>
                            <div className="modal-body" style={{ padding: '24px', fontSize: '0.95rem', color: '#475569', textAlign: 'center' }}>
                                <div style={{ fontSize: '3rem', marginBottom: '10px' }}>⚡</div>
                                <p style={{ margin: 0, lineHeight: '1.5' }}>
                                    Las tablas de ISR del SAT se han actualizado con éxito para todo el corporativo y todos los condominios del sistema.
                                </p>
                            </div>
                            <div className="modal-footer" style={{ padding: '15px 24px', background: '#f8fafc', borderTop: '1px solid #e2e8f0', display: 'flex', justifyContent: 'center' }}>
                                <button 
                                    onClick={() => setShowSATSuccessModal(false)} 
                                    style={{ 
                                        background: '#7e22ce', 
                                        color: 'white', 
                                        border: 'none', 
                                        padding: '10px 24px', 
                                        borderRadius: '8px', 
                                        fontWeight: '600', 
                                        cursor: 'pointer' 
                                    }}
                                >
                                    Aceptar
                                </button>
                            </div>
                        </div>
                    </div>
                )}
            </main>
        </div>
    );
}

export default NominasDashboardScreen;
